App.directive('appLayout', function() {
    return {
        restrict: 'E',
        transclude: true,
        templateUrl: 'common/views/appLayoutView.html'
    };
});